import { render, staticRenderFns } from "./AddNotificacionPage.vue?vue&type=template&id=604b2bad"
import script from "./AddNotificacionPage.vue?vue&type=script&lang=js"
export * from "./AddNotificacionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports